/**
 * @desc purchaseStockCancelOccupy
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: Array<defs.wms.PurchaseStockOccupyRequestDto>, options?: any) {
  return updateResponse(
    http(URL + `/purchaseStock/cancelOccupy`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
